module.exports = __webpack_public_path__ + "e8cdc351369ceaaa88081417e57cf3c2.png";